import formTracking from './form-tracking.js';

export default formTracking;
